import {
	Directive,
	DOCUMENT,
	effect,
	ElementRef,
	inject,
	Inject,
	input,
	OnDestroy,
	OnInit,
} from '@angular/core';

@Directive({
	selector: '[uiBadge]',
	host: {
		class: 'relative',
	},
})
export class BadgeDirective implements OnInit, OnDestroy {
	@Inject(DOCUMENT) private document: Document = inject(DOCUMENT);
	private el: ElementRef = inject(ElementRef);

	badgeText = input<string>('', {
		alias: 'uiBadge',
	});
	styleClasses = input<string[]>([]);

	private badge: HTMLElement | null = null;

	private classes: string[] = [
		'absolute',
		'top-0',
		'right-0',
		'-translate-y-1/2',
		'translate-x-1/2',
		'rounded-full',
		'bg-error',
		'text-white',
		'dark:text-secondary-800',
		'text-[10px]',
		'font-semibold',
		'px-1.5',
		'h-4',
		'flex',
		'items-center',
	];

	constructor() {
		effect(() => {
			const badgeText = this.badgeText();
			if (badgeText && this.badge) {
				if (this.badge.innerText === badgeText) {
					return;
				}
				this.badge.innerText = badgeText;
			} else if (badgeText && !this.badge) {
				this.createBadge();
			} else if (!badgeText && this.badge) {
				this.destroyBadge();
			}
		});
	}

	ngOnInit() {
		this.createBadge();
	}

	private createBadge() {
		if (!this.badgeText()) {
			return;
		}

		this.badge = this.document.createElement('span');
		this.badge.innerText = this.badgeText();

		this.badge.classList.add(...this.classes, ...this.styleClasses());

		this.el.nativeElement.appendChild(this.badge);
	}

	ngOnDestroy() {
		this.destroyBadge();
	}

	private destroyBadge() {
		if (this.badge) {
			this.el.nativeElement.removeChild(this.badge);
			this.badge = null;
		}
	}
}
